/**
 * SPDX-License-Identifier: MPL-2.0
 * Copyright 2021 (c) Moritz Walker, ISW University of Stuttgart (for umati and VDW e.V.)
 * Copyright 2024 (c) Daniel Littfinski, ISW University of Stuttgart (for umati and VDW e.V.)
 * Copyright 2026 (c) Nico Brandt, ISW University of Stuttgart (for umati and VDW e.V.)
 */
import React, { useState, useEffect } from 'react';
import 'bootstrap';
import { Company } from 'Api/generated';
import AddCompany from './AddCompany';
import { connect } from 'react-redux';
import { CompanyDataActions } from './CompanyDataActions';
import { RootState } from '../index';
import { Dispatch } from '@reduxjs/toolkit';
import CompanyDetails from './CompanyDetails';
import { AllowedRoles } from 'Contexts/Auth';

type StateProps_t = ReturnType<typeof mapStateToProps>;
type DispatchProps_t = ReturnType<typeof mapDispatchToProps>;

type CompanyDataProps = StateProps_t & DispatchProps_t;

function CompanyData({ companies, QueryCompanys, querying }: CompanyDataProps) {
  // All company data from DB
  useEffect(() => {
    QueryCompanys();
  }, [QueryCompanys]);

  // Selected Company in dropdownmenu
  const [selectedCompany, setSelectedCompany] = useState<Company | null>(null);

  useEffect(() => {
    if (companiesAZ.length === 1) {
      setSelectedCompany(companiesAZ[0]);
    }
  }, [companies]);
  const handleSelectCompany = (SelectedCompany: Company) => {
    setSelectedCompany(SelectedCompany);
  };

  let companiesAZ = companies.slice();
  companiesAZ = companiesAZ.sort((a, b) => {
    return a.Name.localeCompare(b.Name);
  });

  return (
    <div className="dynamic-form">
      <AllowedRoles roles={['SuperAdmin']}>
        <h2>Create new Company </h2>
        {!querying !== false ? <AddCompany companies={companies} /> : <label>Loading Data ...</label>}
      </AllowedRoles>
      <div className="row-section">
        <h2>Create new Client for Company </h2>
        <div className="card">
          <div className="card-body">
            {companies.length > 1 && (
              <button
                id="btnGroupDrop1"
                type="button"
                className="btn btn-primary dropdown-toggle"
                data-bs-toggle="dropdown"
                aria-haspopup="true"
                aria-expanded="false"
              >
                Select company
                <div className="dropdown-menu" aria-labelledby="btnGroupDrop1">
                  {!querying ? (
                    companiesAZ.map((company) => (
                      <a
                        className="dropdown-item"
                        key={company.Id}
                        href="#"
                        onClick={() => handleSelectCompany(company)}
                      >
                        {company.Name}{' '}
                      </a>
                    ))
                  ) : (
                    <label> Loading Data ...</label>
                  )}
                </div>
              </button>
            )}
            {selectedCompany != null && (
              <CompanyDetails
                company={selectedCompany}
                onDelete={() => setSelectedCompany(null)}
                companies={companies}
              />
            )}
          </div>
        </div>
      </div>
    </div>
  );
}

const mapStateToProps = (state: RootState) => {
  return {
    companies: state.companies.Companies,
    querying: state.companies.Querying,
  };
};

const mapDispatchToProps = (dispatch: Dispatch) => {
  return {
    QueryCompanys: () => CompanyDataActions.QueryCompanys()(dispatch),
  };
};

export default connect(mapStateToProps, mapDispatchToProps)(CompanyData);
